import _ from 'lodash';

const experiencePhases = {
  PRELIVE:  'prelive',
  LIVE:     'live',
  JUDGE:    'judge',
  VOTE:     'vote',
  ENTRY:    'entry',
  POSTLIVE: 'postlive',
};

experiencePhases.ALL = _.values(experiencePhases);

export default experiencePhases;
